import PropTypes from 'prop-types';
import React from 'react';

import Answer from './Answer';
import NoAnswers from './NoAnswers';

import styles from './Answers.module.css';

const Answers = ({ answers, children, i18n, generateUri }) => {
  if (!answers || !answers.length) {
    return (
      <div className={styles.answers}>
        <NoAnswers message={i18n('page.question.answers.no-answers')} />
      </div>
    );
  }

  const topAnswer = answers[0];
  const otherAnswers = answers.slice(1) || [];
  const title =
    answers.length > 1
      ? i18n('page.question.answers.total-plural', answers.length)
      : i18n('page.question.answers.total', answers.length);

  return (
    <div className={styles.answers}>
      <h2 className={styles.totalAnswers}>{title}</h2>

      <Answer
        isTop={topAnswer.netRating > 0}
        answer={topAnswer}
        generateUri={generateUri}
        i18n={i18n}
      />

      <div className={styles.inlineSearch}>{children}</div>

      {otherAnswers.map((answer) => (
        <Answer
          key={answer.id}
          answer={answer}
          generateUri={generateUri}
          i18n={i18n}
        />
      ))}
    </div>
  );
};

Answers.propTypes = {
  answers: PropTypes.array,
  children: PropTypes.object,
  i18n: PropTypes.func,
  generateUri: PropTypes.func,
};

export default Answers;
